import {
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HotDocComponent } from "@components/hot-doc/hot-doc.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { HotDoc } from "~app/common/components/hot-doc/hotdoc/doc";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { FormBinderService } from "~app/common/services/form-binder.service";
import { IProduktdefinitionBasdata } from "../../../models/ProduktdefinitionModels";
import { ProduktdefinitionViewModel } from "../../../models/ProduktdefinitionViewModel";

@Component({
    selector: "rask-fordelningsmatris",
    templateUrl: "./fordelningsmatris.component.html",
    styleUrls: ["./fordelningsmatris.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        FormsModule,
        ReactiveFormsModule,
        HotDocComponent,
        InputNumberComponent,
        SelectorComponent,
        CheckboxComponent
    ]
})
export class FordelningsmatrisComponent implements OnChanges, OnInit {
    @Input() basData: IProduktdefinitionBasdata;
    fordelningstyper: string[];
    form: UntypedFormGroup;
    hotDoc: HotDoc;
    @Input() rootForm: UntypedFormGroup;
    @Input() viewModel: ProduktdefinitionViewModel;

    private readonly formBinder = inject(FormBinderService);
    private readonly formId = "produktinstruktioner-details-fordelningsmatris";
    private readonly raskModalService = inject(RaskModalService);

    initMatrisSettings = () => {
        this.hotDoc = this.viewModel.fordelningsmatrisdata.matrisdata.fordelningsmatris.getFordelningsmatris(this.raskModalService, this.rootForm);
    };

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.viewModel && changes.viewModel.currentValue.fordelningsmatrisdata !== changes.viewModel.previousValue?.fordelningsmatrisdata) {
            this.initMatrisSettings();
            if (this.form) {
                this.formBinder.reBindForm(this.form, this.viewModel.fordelningsmatrisdata);
            }
        }
    }

    ngOnInit(): void {
        this.initializeForm();
        this.rootForm.addControl(this.formId, this.form);
    }

    private initializeForm() {
        this.fordelningstyper = this.basData.fordelningstyper;
        this.form = this.formBinder.CreateGroup(this.viewModel.fordelningsmatrisdata);
        if (!this.viewModel.canEdit) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }
}
